import { createComponent, createHook } from 'reakit-system';
import {
  DialogBackdropHTMLProps,
  DialogBackdropOptions,
  useDialogBackdrop,
} from 'reakit';
import { BoxHTMLProps, BoxOptions, useBox } from '../Box/Box';

type ModalBackdropOptions = DialogBackdropOptions & BoxOptions;
type ModalBackdropProps = DialogBackdropHTMLProps & BoxHTMLProps;

/**
 * @internal
 */
export const useModalBackdrop = createHook<
  ModalBackdropOptions,
  ModalBackdropProps
>({
  compose: [useDialogBackdrop, useBox],
  useOptions(options) {
    return {
      position: 'fixed',
      overflow: 'hidden',
      left: 0,
      top: 0,
      py: ['sp-0', 'sp-32'],
      size: '100%',
      display: 'flex',
      justifyContent: 'center',
      zIndex: 1010,
      ...options,
      styles: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        label: 'ModalBackdrop',
        ...options.styles,
      },
    };
  },
});

/**
 * @internal
 */
export const ModalBackdrop = createComponent({
  useHook: useModalBackdrop,
  as: 'div',
});
